// extracted by mini-css-extract-plugin
export default {"container":"s8LKdnz9i4mi6jr7CzOC"};